<template>
  <div class="mt-200">
    <h3 class="text-uppercase mb-100">Change Email</h3>

    <form-field-input
      label="Email Address"
      type="email"
      v-model="form.email_address"
      :validation-errors="validationErrors.email_address"
    ></form-field-input>

    <form-field-password
      label="Password"
      v-model="form.password"
      :validation-errors="validationErrors.password"
    ></form-field-password>

    <div class="flex flex-end mt-100">
      <button-default
        :loading="isSaving"
        :disabled="isSaving || user.email_address === form.email_address"
        @click="save"
      >
        Save
      </button-default>
    </div>
  </div>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";

export default {
  name: 'ProfileChangePassword',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mixins: [FormMixin],
  data() {
    return {
      isSaving: false,
      validationErrors: {},
      form: {
        id: this.user.id,
        password: '',
        email_address: this.user.email_address
      },
    }
  },
  methods: {
    update() {
      return this.$api.users.updateEmail(this.form)
        .then((res) => {
          this.form.password = '';

          this.$buefy.toast.open({
            message: "Your email has been changed",
            type: 'is-success'
          });

          return res;
        })
    },
  }
}
</script>
